const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  TRY: '₺',
  JPY: '¥',
  CNY: '¥',
  KRW: '₩',
  INR: '₹',
  RUB: '₽',
  BRL: 'R$',
  CAD: 'CA$',
  AUD: 'A$',
  CHF: 'Fr',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  MXN: 'MX$',
  SGD: 'S$',
  HKD: 'HK$',
  AED: 'د.إ',
  SAR: '﷼',
  THB: '฿',
  IDR: 'Rp',
  MYR: 'RM',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  ZAR: 'R',
  ILS: '₪',
  NGN: '₦',
};

export const getCurrencySymbol = (code: string): string => CURRENCY_SYMBOLS[code?.toUpperCase()] ?? code ?? '$';